import React, { createContext, useState, useContext, ReactNode} from 'react';
import { Event } from '../types/eventTypes'

interface SelectedEventProps {
    selectedEvent: Event | undefined;
    setContextSelectedEvent: (selectedEvent: Event | undefined) => void;
}

const SelectedEventContext = createContext<SelectedEventProps | undefined>(undefined);

const SelectedEventProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

    const [selectedEvent, setContextSelectedEvent] = useState<Event | undefined>();

    return (
        <SelectedEventContext.Provider value={{selectedEvent, setContextSelectedEvent}}>
            {children}
        </SelectedEventContext.Provider>
    );
};

const useSelectedEvent = () => {
    const context = useContext(SelectedEventContext);
    if (context === undefined) {
        throw new Error('usePage must be used within a PageProvider');
    }
    return context;
};

export { SelectedEventProvider, useSelectedEvent };